module.exports = __webpack_public_path__ + "img/background-1.f71354e2.jpg";